import React, { FC } from 'react';
import Tooltip from 'HOC/Tooltip';
import Pill from 'Components/Pill';
import injectSheet from 'react-jss';
import { AttributeObject } from '../classes/attributes.classes';
import styleSheet from './styles';

interface Props {
  classes?: any;
  text?: string;
  groupCount?: string;
  attribute?: AttributeObject;
  focusOnHover?: boolean;
}

const ListMembershipPill: FC<Props> = (props: Props) => {
  const { classes, text, groupCount, attribute, focusOnHover } = props;

  const tooltipDescription = (
    <div>
      <div className={classes.pillDescriptionTitle}>
        Inquiries who are on
        <span className={classes.strongText}> ANY </span>
        of the following lists:
      </div>

      <div>
        {attribute.attributes.map((toolText: string) => (
          <div key={toolText}>
            <>- </>
            <span className={classes.strongText}>{toolText}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className={classes.pillContainerHorizontal}>
      <Tooltip
        position="right"
        offsetTop={-5}
        offsetLeft={76}
        text={tooltipDescription}
        width="365px"
        overrideEvents={{
          showToolTip: ['onMouseEnter', 'onFocus'],
          hideToolTip: ['onBlur', 'onMouseLeave'],
        }}
        parentText="List Membership"
      >
        <Pill text={text} groupCount={groupCount} focusOnHover={focusOnHover} />
      </Tooltip>
    </div>
  );
};

ListMembershipPill.defaultProps = {
  classes: {},
  text: '',
  groupCount: '',
  attribute: { label: '', attributes: [], type: 'engagement' },
  focusOnHover: false,
};

export default injectSheet(styleSheet)(ListMembershipPill);
